module.exports = __webpack_public_path__ + "img/no-available.2db0e67a.png";